module.exports = __webpack_public_path__ + "img/slow_brand_logo.b285d8de.png";